import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function requireDependentValidator(dependentField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const dependent = control.parent?.controls[dependentField];

    if (!value) {
      return dependent?.setErrors(null);
    }

    return !dependent.value ? dependent.setErrors({ required: true }) : dependent.setErrors(null);
  }
}